import { yupResolver } from '@primeuix/forms/resolvers/yup'
import { type FormProps } from '@primevue/forms'
import * as yup from 'yup'

const requiredString: yup.StringSchema = yup.string().required('Поле обязательно для заполнения')

export const formResolver: FormProps['resolver'] = yupResolver(
    yup.object().shape({
        birthday: requiredString,
        comment: yup.string().nullable(),
        email: requiredString.email('Некорректный e-mail адрес'),
        name: requiredString.matches(/^[А-Яа-я]+((\s)?((-)?([А-Яа-я])+))*$/, {
            message: 'Введите корректное имя кириллицей',
        }),
        phone: requiredString.matches(/^(\+7\s9)[\d\s-]*$/, {
            message: 'Номер телефона должен начинаться на +79',
        }),
    }),
)
